module.exports = __webpack_public_path__ + "img/slot.e780f86f.png";